<template>
    <div class="flex-expand"></div>
</template>